import { translate } from '../i18n'
import { StringValidator } from './StringValidator'

export class PasswordValidator extends StringValidator {
    isValidString = (value: string) => !!value && value.length >= 8
    getMessage = () => translate('validations.password') as string
}

export const PASSWORD_VALIDATOR = new PasswordValidator()
